var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "261px",
    viewBox: "0 0 300 261",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF0FB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F6FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF0FB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F6FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.3533068,8.76489905 L71.8349065,48.5616737 C81.9268783,66.4264136 77.4091484,90.2387114 61.7442742,101.747929 C61.0371162,102.267489 60.313168,102.756707 59.5739471,103.214558 L12.5054726,132.367325 L0.019148511,97.5786334 L45.2118045,67.9801928 L21.6995114,27.8580589 C16.9148091,19.6932888 18.8398491,8.65096025 25.9992086,3.1943277 C26.1912661,3.04794769 26.3861524,2.90645332 26.583723,2.7699494 C34.344933,-2.59236224 44.4387705,0.0652202602 49.3533068,8.76489905 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3003812,3.49154522 L50.6240933,8.4050302e-15 L50.6240933,8.4050302e-15 C60.3127205,9.72387972 65.4933488,23.0564494 64.9121299,36.7708768 L63.6863117,65.6952572 C63.5091452,69.8756733 63.837184,74.0621928 64.6633117,78.1639948 L75.1064232,130.015029 L75.1064232,130.015029 L7.02446785,130.306182 L10.1302341,73.5279459 C2.22078441,69.0205632 -1.54179347,59.6588665 1.04846279,50.9315264 L4.77152385,38.3874315 C9.72055032,21.7126962 22.6789048,8.61659929 39.3003812,3.49154522 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "99.6225718%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCFC3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBDA5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.7362673,30.6845814 L12.7422789,63.4996871 C14.1811095,87.0366279 34.4279726,104.950686 57.9649134,103.511855 C59.9629109,103.389716 61.949846,103.127223 63.9110158,102.726317 L104.071434,94.5166612 L104.071434,94.5166612 L96.0442044,61.4861954 L44.6982419,70.671714 L42.6737533,25.7429452 C42.3102207,17.675194 35.4753148,11.4296908 27.4075635,11.7932234 C26.8831188,11.8168548 26.3603273,11.8687115 25.8414596,11.9485681 C16.7213012,13.3522116 10.1732319,21.4742342 10.7362673,30.6845814 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18233D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "99.6225718%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCFC3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBDA5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-12",
    cx: 37.3443983,
    cy: 37.3205742,
    rx: 37.3443983,
    ry: 37.3205742
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18233D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18233D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "99.6225718%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD5F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBDA5",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "8.-V3-Finance-dashboard---uploaded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Financing_Daashboard-Copy-3",
    transform: "translate(-567.000000, -285.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(442.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(125.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Make-a-conversation-with-other"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    opacity: 0.391369048,
    x: 0,
    y: 31.1004785,
    width: 227.80083,
    height: 197.799043,
    rx: 98.8995215
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-2)",
    opacity: 0.391369048,
    x: 204.149378,
    y: 65.9330144,
    width: 95.8506224,
    height: 102.009569,
    rx: 47.9253112
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(143.153527, 111.961722)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 0,
    y: 7.97727273,
    width: 117.339898,
    height: 62.9318182,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(7.875161, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 117.339898,
    height: 62.9318182,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(7.830293, 8.420455)",
    fill: "#FBCDDF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-28",
    points: "6.30012877 44.7753276 0 44.7753276 0 35.4545455 6.30012877 35.4545455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-28",
    points: "18.1128702 44.7753276 11.8127414 44.7753276 11.8127414 17.7272727 18.1128702 17.7272727"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-28",
    points: "29.9256116 44.7753276 23.6254829 44.7753276 23.6254829 26.5909091 29.9256116 26.5909091"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-28",
    points: "41.7383531 44.7753276 35.4382243 44.7753276 35.4382243 8.86363636 41.7383531 8.86363636"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-28",
    points: "53.5510945 44.7753276 47.2509657 44.7753276 47.2509657 13.2954545 53.5510945 13.2954545"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-28",
    points: "65.3638359 44.7753276 59.0637072 44.7753276 59.0637072 0 65.3638359 0"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-26",
    fill: "#18233D",
    fillRule: "nonzero",
    points: "93.9460915 19.4638239 93.9460915 21.4897979 86.0709306 21.4897979 86.0709306 19.4638239"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-26",
    fill: "#18233D",
    fillRule: "nonzero",
    points: "96.3086398 28.3274602 96.3086398 30.3534343 86.0709306 30.3534343 86.0709306 28.3274602"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-26",
    fill: "#18233D",
    fillRule: "nonzero",
    points: "93.9460915 37.1910966 93.9460915 39.2170706 86.0709306 39.2170706 86.0709306 37.1910966"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-26",
    fill: "#18233D",
    fillRule: "nonzero",
    points: "101.821252 46.054733 101.821252 48.080707 86.0709306 48.080707 86.0709306 46.054733"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(119.502075, 161.100478) scale(-1, 1) translate(-119.502075, -161.100478) translate(27.385892, 62.200957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1267",
    transform: "translate(106.452149, 64.070859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAD417",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-1267",
    transform: "translate(93.185044, 66.515834)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAD417",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.653912,189.684866 L101.793548,168.427821 L129.051239,98.7015956 L124.94176,166.818147 C124.166773,179.663918 113.52304,189.684866 100.653912,189.684866 L100.653912,189.684866 L100.653912,189.684866 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-13-+-Path-14-+-Path-14-+-Path-14-Mask",
    transform: "translate(21.070628, 133.965127) scale(-1, 1) translate(-21.070628, -133.965127) translate(0.713460, 112.553890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.44171959,12.0162934 L16.0677194,3.72535524 C17.0152696,3.14880454 18.2243285,3.23731609 19.0778114,3.94571498 C19.8723999,4.60523096 19.9988833,5.7768794 19.3633552,6.59078128 L10.4089654,18.0584016 L10.4089654,18.0584016 C16.302993,17.2322944 20.4348836,16.2575921 22.8046371,15.1342947 C24.6063327,14.280265 26.5989314,12.7670279 28.7824333,10.5945835 C30.4835233,8.90208667 33.234569,8.90907015 34.9270552,10.6101709 C35.4346077,11.1203067 35.8075078,11.7485193 36.0122663,12.4383903 C37.4056971,17.1331283 36.3084187,22.2143324 33.1018594,25.9157094 L30.3582168,29.0827352 C25.2702625,34.9558333 18.2289231,38.7894215 10.5346985,39.8754553 L5.3071356,40.6133217 L5.3071356,40.6133217 L2.44171959,12.0162934 Z",
    id: "Mask",
    fill: "url(#linearGradient-7)",
    transform: "translate(20.345350, 21.687540) rotate(-6.000000) translate(-20.345350, -21.687540) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.46666,6.72916909 C32.9344108,5.92639058 33.8838429,5.70834926 34.5872761,6.24216018 C35.2907092,6.77597109 35.4817675,7.8594909 35.0140167,8.6622694 C30.5227712,16.3703811 26.1932971,20.759248 21.8878954,21.7218844 C21.0589019,21.9072375 20.2552062,21.2905531 20.092791,20.3444814 C19.9303757,19.3984097 20.4707441,18.4812087 21.2997377,18.2958557 C24.616811,17.5541977 28.3850181,13.7342974 32.46666,6.72916909 Z",
    id: "Path-14",
    fill: "#C1C1C1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5155006,15.9640322 C36.9832514,15.1612537 37.9326835,14.9432124 38.6361167,15.4770233 C39.3395498,16.0108342 39.5306081,17.094354 39.0628573,17.8971325 C34.5716118,25.6052442 30.2421377,29.9941111 25.936736,30.9567475 C25.1077425,31.1421005 24.3040468,30.5254162 24.1416316,29.5793445 C23.9792163,28.6332728 24.5195848,27.7160718 25.3485783,27.5307188 C28.6656516,26.7890608 32.4338587,22.9691605 36.5155006,15.9640322 Z",
    id: "Path-14",
    fill: "#C1C1C1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1228179,9.88579908 C35.5526558,9.05587478 36.4906363,8.78075241 37.2178559,9.27129607 C37.9450755,9.76183973 38.1861509,10.8322905 37.756313,11.6622148 C33.2731448,20.3182448 28.9568814,25.2406541 24.62227,26.3309674 C23.7973166,26.5384734 22.9811601,25.9434853 22.7993334,25.0020243 C22.6175067,24.0605634 23.1388639,23.1291417 23.9638173,22.9216358 C27.2516808,22.0946178 31.0330986,17.7821641 35.1228179,9.88579908 Z",
    id: "Path-14",
    fill: "#C1C1C1",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-1267",
    transform: "translate(22.724546, 69.366433)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAD417",
    transform: "translate(56.906910, 61.021950) scale(-1, 1) rotate(-12.000000) translate(-56.906910, -61.021950) ",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-184.845490, -201.536414)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(98.923720, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.08615637,21.7144492 L2.94593343,17.7748377 C0.446423518,15.859143 -0.36203844,12.4503015 1.0109745,9.61617526 C2.31421283,6.92607537 5.54941052,5.79902267 8.24201274,7.09708308 L10.8851531,8.37129874 L10.8851531,8.37129874 C20.4952099,-0.372894567 28.9996233,-2.24272549 36.3983935,2.76180598 C47.4965487,10.2686032 48.2108648,24.7827781 53.926832,37.4029127 C59.6427992,50.0230474 74.5471425,64.4504987 67.1686567,77.9668291 C59.7901709,91.4831596 38.1802272,88.0270753 34.3446449,70.3335893 C31.78759,58.5379321 31.8956944,48.9475123 34.668958,41.5623301 L8.08615637,21.7144492 Z",
    id: "Path-19",
    fill: "url(#linearGradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.896827,15.4207727 L44.9805712,41.1378053 C45.6189003,49.0158975 39.9310327,55.9957766 32.0862868,56.9610547 L32.0862868,56.9610547 L32.0862868,56.9610547 L33.1925969,76.2861079 L14.9991798,70.3411301 L15.9996447,58.8986037 C16.5219383,52.925022 16.0456741,46.9061628 14.5903997,41.0890634 L14.5903997,41.0890634 L14.5903997,41.0890634 L11.8006877,42.7616907 C9.82362797,43.9470762 7.28374654,43.5647249 5.74329431,41.8498164 C4.1617329,40.0891432 3.89471205,37.5099565 5.08203401,35.4626233 L5.25549347,35.1635221 C6.4427563,33.1162909 9.06483182,32.4191487 11.1120631,33.6064116 C11.1207874,33.6114711 11.1294939,33.6165615 11.1381823,33.6216825 L13.9217486,35.2623451 L13.9217486,35.2623451 C24.2018913,32.7756218 33.3918422,27.0069818 40.1000798,18.8298994 L42.896827,15.4207727 L42.896827,15.4207727 Z",
    id: "Path",
    fill: "url(#linearGradient-11)",
    transform: "translate(24.638487, 45.853440) scale(-1, 1) translate(-24.638487, -45.853440) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.190688,56.9610547 C21.6951824,56.933045 25.2834541,55.4535099 27.9555029,52.5224495 C25.4336975,60.9345984 21.6946566,65.3698663 16.7383803,65.8282533 L17.190688,56.9610547 Z",
    id: "Path-21",
    fill: "#0D152A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(15.052670, 35.291364) scale(-1, 1) translate(-15.052670, -35.291364) translate(2.838370, 22.036789)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#18233D",
    cx: 18.6318329,
    cy: 10.4816213,
    rx: 1.34961353,
    ry: 1.53914385
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#18233D",
    cx: 6.48531105,
    cy: 12.0207651,
    rx: 1.34961353,
    ry: 1.53914385
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7595988,10.549693 C14.4715071,10.0307216 15.4172688,10.2686336 15.8720164,11.0810843 L16.8309694,12.8136135 C18.2526632,15.4223057 18.8117814,16.69524 18.8117814,17.5102679 C18.8117814,19.4517535 17.5346122,19.9229216 15.4740223,19.9229216 C14.6292685,19.9229216 13.9444602,19.1413983 13.9444602,18.1773405 C13.9444602,17.3337899 14.4687666,16.6299924 15.1657622,16.4672235 L15.1604948,16.4310021 C14.8115617,15.7348165 14.3377223,14.8444092 13.7404194,13.7631202 L13.2939681,12.9604459 C12.8392204,12.1479952 13.0476904,11.0686643 13.7595988,10.549693 Z",
    id: "Path-16",
    fill: "#18233D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5829923,22.7947721 L9.18453812,22.7947721 C10.0154005,24.8469639 11.0754379,25.8730598 12.3646502,25.8730598 C13.6538626,25.8730598 14.3933099,24.8469639 14.5829923,22.7947721 Z",
    id: "Path-17",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35190855,3.29829309 C9.61902177,3.30589332 10.6408212,4.48432321 10.6341939,5.93038992 C10.6278046,7.31072633 9.68665766,8.43597592 8.49905192,8.52880917 L8.32779169,8.53496389 C7.24816911,8.52848824 6.30121275,9.07046146 5.36054125,10.3228282 C4.53587487,11.4207511 3.08745278,11.547854 2.12539995,10.6067206 C1.16334713,9.66558719 1.0519734,8.01260548 1.87663978,6.91468263 C3.65820872,4.54278374 5.85875876,3.28333901 8.35190855,3.29829309 Z",
    id: "Path-5",
    fill: "#18233D",
    fillRule: "nonzero",
    transform: "translate(5.979216, 7.267668) rotate(22.000000) translate(-5.979216, -7.267668) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4851104,1.54635844 C21.7522286,1.55279377 22.7748596,2.7302839 22.7692438,4.17635627 C22.763838,5.55669807 21.8234857,6.68281253 20.6359458,6.77673756 L20.46469,6.78304972 C19.5202828,6.77825335 19.0871442,6.97299313 18.8774834,7.31053016 L18.8329363,7.39093236 C18.2118413,8.65138963 16.8129918,9.09858663 15.7085185,8.38977482 C14.6040452,7.68096301 14.2121896,6.08455501 14.8332846,4.82409774 C15.9280596,2.60234893 17.9318161,1.533391 20.4851104,1.54635844 Z",
    id: "Path-5",
    fill: "#18233D",
    fillRule: "nonzero",
    transform: "translate(18.653814, 5.136297) rotate(18.000000) translate(-18.653814, -5.136297) "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(212.863071, 10.574163) scale(-1, 1) translate(-212.863071, -10.574163) translate(200.414938, 0.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2.60000014
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.573269273,
    y1: 0.971815903,
    x2: 24.2861685,
    y2: 0.971815903,
    id: "Path-29"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.1590276,
    y1: 10.1562315,
    x2: 24.2861685,
    y2: 10.1562315,
    id: "Path-29"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.80757261,
    y1: 19.914673,
    x2: 24.2861685,
    y2: 19.914673,
    id: "Path-29"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(130.705394, 19.904306)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#E1E8FF",
    transform: "translate(28.137985, 23.885198) rotate(17.000000) translate(-28.137985, -23.885198) ",
    points: "9.73423549 10.2024258 46.4251252 10.361711 46.541734 37.5679707 9.85084429 37.4086855"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C8D3F5",
    opacity: 0.200000003,
    transform: "translate(33.899367, 18.906928) rotate(17.000000) translate(-33.899367, -18.906928) ",
    points: "15.4956173 5.22415567 52.186507 5.3834409 52.3031158 32.5897006 15.6122261 32.4304154"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#E1E8FF",
    opacity: 0.200000003,
    transform: "translate(28.137985, 23.885198) rotate(17.000000) translate(-28.137985, -23.885198) ",
    points: "9.73423549 10.2024258 46.4251252 10.361711 46.541734 37.5679707 9.85084429 37.4086855"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#8ECCFF",
    transform: "translate(21.704187, 28.098423) rotate(17.000000) translate(-21.704187, -28.098423) ",
    points: "3.30043801 14.4156503 39.9913277 14.5749355 40.1079365 41.7811953 3.41704682 41.62191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5816276,13.0992737 C42.009279,12.7284054 42.6080897,12.8411484 42.9191089,13.3510924 C43.2128492,13.8327062 43.1448326,14.4963681 42.7761061,14.8810491 L42.7079276,14.9459442 L33.6633957,22.7895549 C28.0230761,27.6809602 20.4054155,27.7385062 14.7185701,22.9621927 L14.516296,22.7895549 L5.47176417,14.9459442 C5.04411283,14.5750759 4.94956377,13.8610364 5.26058292,13.3510924 C5.55432323,12.8694787 6.10476654,12.7421583 6.52528282,13.0419254 L6.59806415,13.0992737 L15.642596,20.9428844 C20.6123326,25.2527458 27.3218659,25.3094545 32.3373865,21.1130105 L32.5370958,20.9428844 L41.5816276,13.0992737 Z",
    id: "Path-56",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(24.089846, 19.691305) rotate(17.000000) translate(-24.089846, -19.691305) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(168.049793, 19.904306)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#ECF0FB",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.203320, 6.220096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9897877,44.6883097 C29.5336746,44.9185077 27.255451,46.0689392 25.6121704,47.9088064 L15.0438439,59.7414286 L15.0438439,59.7414286 L10.7849343,31.382932 L0,33.1931809 L4.00056264,71.1405352 C4.4272909,75.188268 7.33760252,78.5381227 11.2859924,79.5262802 C15.32006,80.5358802 19.5793625,79.1952577 22.3079199,76.0571104 L29.8369608,67.3978681 L29.8369608,67.3978681 L31.9897877,44.6883097 Z",
    id: "Path-70",
    fill: "#FF72AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9897877,44.6883097 L55.3675593,42.9222204 C58.6700936,42.6727283 61.8340359,44.2944039 63.5598392,47.1211657 C65.3734577,50.0917637 66.0569879,53.6160075 65.4853938,57.0492196 L63.6727258,67.9367966 C62.6852038,73.868231 63.2119295,79.9530089 65.2040274,85.6265141 L65.2040274,85.6265141 L65.2040274,85.6265141 L26.4275667,84.8816195 L30.3253257,68.6545957 C27.1892904,64.415582 26.4508463,58.8627634 28.3700252,53.9514797 L31.9897877,44.6883097 L31.9897877,44.6883097 Z",
    id: "Path-69",
    fill: "#FF72AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.411102,45.5956622 L81.5874857,68.3651031 C83.9436092,71.1626909 84.5734655,75.0280122 83.2273831,78.4288765 C81.950191,81.6556901 78.6043686,83.5636529 75.1768837,83.0196918 L49.4631892,78.9387842 L49.4631892,78.9387842 L51.4154346,70.6299712 L68.7104063,71.222688 L64.3371549,67.2486908 C58.1568756,61.6326374 57.3191157,52.2143919 62.411102,45.5956622 L62.411102,45.5956622 L62.411102,45.5956622 Z",
    id: "Path-71",
    fill: "#FF72AA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(32.914921, 0.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-14)",
    transform: "translate(20.275556, 11.020484) rotate(27.000000) translate(-20.275556, -11.020484) ",
    cx: 20.2755556,
    cy: 11.0204837,
    rx: 8.10093654,
    ry: 8.16899365
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00867699,26.452324 L1.13176061,23.69004 C0.0589723312,22.9256835 -0.264410807,21.4751792 0.382100958,20.3275129 C1.03092369,19.1757443 2.43782006,18.6901034 3.6589772,19.1963812 L5.14239513,19.8113893 L5.14239513,19.8113893 C9.7753574,16.1860622 13.8752943,15.4108336 17.442206,17.4857035 C21.0091176,19.5605734 21.7062325,24.7364625 19.5335506,33.0133708 L5.00867699,26.452324 Z",
    id: "Path-19",
    fill: "url(#linearGradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5750696,22.7340888 L21.4919677,32.4658663 C21.845665,36.2199404 19.1131232,39.5598162 15.36336,39.9566165 L15.36336,39.9566165 L15.36336,39.9566165 L15.8967068,47.9687495 L7.12574764,45.5039722 L6.60632322,34.2930484 L5.66641511,34.512813 C4.59097691,34.7642666 3.46130228,34.4553006 2.66352964,33.6915238 C1.9246267,32.984108 1.80260537,31.8473402 2.37453602,30.9992188 L2.4283632,30.9193979 C3.02459776,30.035236 4.18596687,29.7335192 5.13716092,30.2156684 L6.60632322,30.9603697 L6.60632322,30.9603697 C11.5798232,29.9257397 16.1211159,27.4031576 19.627528,23.7273943 L20.5750696,22.7340888 L20.5750696,22.7340888 Z",
    id: "Path",
    fill: "url(#linearGradient-16)",
    transform: "translate(11.772812, 35.351419) scale(-1, 1) translate(-11.772812, -35.351419) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8943736,31.1118769 C20.4237752,30.973806 20.9665592,31.2846569 21.1067154,31.8061818 C21.2375279,32.2929383 20.9713734,32.7911789 20.5048816,32.9677044 L20.4019243,33.0004856 L18.2014125,33.5743915 C17.6720109,33.7124624 17.129227,33.4016115 16.9890707,32.8800867 C16.8582582,32.3933301 17.1244128,31.8950895 17.5909046,31.718564 L17.6938618,31.6857828 L19.8943736,31.1118769 Z",
    id: "Path-64",
    fill: "#18233D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18226327,39.9566165 C10.3538584,39.9450037 12.083747,39.3315911 13.3719289,38.1163786 C12.1561786,41.6040407 10.3536049,43.442895 7.96420785,43.6329414 L8.18226327,39.9566165 Z",
    id: "Path-21",
    fill: "#0D152A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(7.398440, 30.690602) scale(-1, 1) translate(-7.398440, -30.690602) translate(1.174374, 25.092516)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#18233D",
    cx: 9.39333211,
    cy: 4.73022282,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#18233D",
    cx: 3.53755219,
    cy: 5.03249319,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07769713,4.54602188 C7.53871525,4.25483197 8.15206557,4.38694437 8.44765342,4.84110318 L8.83701339,5.44409567 C9.62460587,6.67694652 9.90578115,7.22359341 9.90578115,7.64428734 C9.90578115,8.66715813 9.17915392,8.89769142 8.04246759,8.89769142 C7.4948273,8.89769142 7.05087714,8.46034662 7.05087714,7.92085446 C7.05087714,7.59715917 7.2106992,7.31023692 7.45684715,7.13249037 L7.52933732,7.08463706 L7.44675028,6.94886566 C7.30253675,6.71348534 7.13094075,6.44147164 6.93225151,6.13340037 L6.77815912,5.89559512 C6.48257127,5.44143631 6.61667901,4.83721179 7.07769713,4.54602188 Z",
    id: "Path-16",
    fill: "#18233D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61290627,9.83523344 L5.01033742,9.83523344 C5.4108922,10.6860685 5.92193113,11.1114861 6.54345421,11.1114861 C7.1649773,11.1114861 7.52146131,10.6860685 7.61290627,9.83523344 Z",
    id: "Path-17",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95213517,1.2026329 C5.7735892,1.20586015 6.43688148,1.86446093 6.43365178,2.67369287 C6.43057849,3.43796748 5.83408024,4.06326473 5.07580187,4.12769322 L4.94039652,4.13315491 C4.58113759,4.13175833 4.26161831,4.26963489 3.92487919,4.60982527 L3.7976836,4.74700325 C3.26211557,5.36060351 2.3230179,5.43032089 1.70015023,4.90272137 C1.07728257,4.37512186 1.00651222,3.44999666 1.54208025,2.8363964 C2.47107944,1.77204207 3.63479792,1.19754584 4.95213517,1.2026329 Z",
    id: "Path-5",
    fill: "#18233D",
    fillRule: "nonzero",
    transform: "translate(3.808067, 3.229790) rotate(22.000000) translate(-3.808067, -3.229790) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4584747,0.64487184 C11.2799306,0.647604645 11.9436275,1.30580973 11.9408917,2.11504345 C11.938139,2.92427717 11.2699928,3.57809918 10.448537,3.57539578 L10.2462109,3.57943941 C10.0541866,3.58928823 10.0058913,3.61528434 9.99263807,3.63840064 C9.58866035,4.3430202 8.68133756,4.59161113 7.96607591,4.19364404 C7.25081425,3.79567694 6.99846877,2.90185386 7.40244649,2.19723431 C8.00606485,1.14440076 9.10174064,0.640436251 10.4584747,0.64487184 Z",
    id: "Path-5",
    fill: "#18233D",
    fillRule: "nonzero",
    transform: "translate(9.575398, 2.514087) rotate(18.000000) translate(-9.575398, -2.514087) "
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.4bea09ad0c2fde90de3225c6fdf235ec.svg";
export { ForwardRef as ReactComponent };